<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>SLS Status</ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>

<ion-content>
  <!--SLS status image-->
  <pinch-zoom class="height-100">
    <img class="img-status" alt="SLS Status" [src]="status_url">
  </pinch-zoom>

  <!--refresh button-->
  <ion-fab vertical="bottom" (click)="doRefresh()" horizontal="end" slot="fixed">
    <ion-fab-button color="dark">
      <ion-icon *ngIf="!refreshIcon" name="refresh"></ion-icon>
      <ion-spinner *ngIf="refreshIcon" name="dots"></ion-spinner>
    </ion-fab-button>
  </ion-fab>

  <ng-container *ngIf="slsstatus">
  <!--general information of the status-->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Information</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-list lines="none">
        <ion-item>
          <ion-label class="ion-text-wrap"><strong>Shift Plan: </strong><span
              class="ion-text-nowrap">{{slsstatus.machine.machine_mode}}</span></ion-label>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap"><strong>Operation Plan: </strong><span
              class="ion-text-nowrap">{{slsstatus.machine.operation_type}}</span></ion-label>

        </ion-item>
        <ion-item>
          <ion-label><strong>Beam Current: </strong><span
              class="ion-text-nowrap ion-text-right">{{slsstatus.machine.beam_current}}</span></ion-label>

        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap"><strong>Uptime: </strong><span
              class="ion-text-nowrap">{{slsstatus.machine.uptime}}</span></ion-label>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap"><strong>Vertical Beam Size: </strong><span
              class="ion-text-nowrap">{{slsstatus.machine.beamsize_y}}</span></ion-label>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>

  <!--SLS status chart-->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Status</ion-card-title>
      <ion-card-subtitle><strong>last update: </strong>{{slsstatus.updated}}</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div echarts [options]="options" style="margin: auto; width: 100%; min-height: 400px" class="demo-chart"></div>
    </ion-card-content>
  </ion-card>

  <!--messages from the control-room-->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Control-Room Message</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-list text-wrap lines="none" *ngIf="slsstatus.machine.messages[0].time">
        <div *ngFor="let msg of slsstatus.machine.messages">
          <ion-item *ngIf="msg.time">
            <ion-label class="ion-text-wrap"><strong>{{msg.time}}</strong> - {{msg.message}}</ion-label>
          </ion-item>
        </div>
      </ion-list>
      <ion-label *ngIf="!slsstatus.machine.messages[0].time">No messages</ion-label>
    </ion-card-content>
  </ion-card>

  <!--Beamlines-->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Beamlines</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-list *ngFor="let beamline of slsstatus.beamlines | keyvalue">
        <ion-item>
          <ion-label class="ion-text-wrap">
            <h1>{{beamline.key}}
              <small>
                <a target="_blank" rel="noopener" [href]="beamline.value.url">
                  (<span [innerHTML]="beamline.value.name"></span><ion-icon name="open-outline"></ion-icon>)
                </a>
              </small>
            </h1>

            <ion-label class="ion-text-wrap" *ngIf="beamline.value.insertion_device_status">
              <strong>ID Status:</strong>
              <span>
                {{beamline.value.insertion_device_status}}
              </span>
            </ion-label>

            <ion-label class="ion-text-wrap" *ngIf="beamline.value.shutter_status">
              <strong>Shutter Status:</strong>
              <span [ngClass]="beamline.value.shutter_status == 'OPEN' ? 'success' : 'danger'">
                {{beamline.value.shutter_status}}
              </span>
            </ion-label>

            <ion-label class="ion-text-wrap" *ngIf="beamline.value.experiment_status"><strong>Experiment
                Status:</strong>
              <span [ngClass]="beamline.value.experiment_status == 'attended' ? 'success' : 'danger'">
                {{beamline.value.experiment_status}}
              </span>
            </ion-label>


          </ion-label>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>


  </ng-container>
</ion-content>
